import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  title: {
    id: 'seo_faq_title',
  },
});
